import { render, staticRenderFns } from "./DragInfo.vue?vue&type=template&id=0b250633&"
import script from "./DragInfo.vue?vue&type=script&lang=js&"
export * from "./DragInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports